import { Loader } from 'components/loader';
import './FetchingSpinner.scss';

const FetchingSpinner = ({ children }: { children?: JSX.Element }) => {
  return (
    <div className="fetchingspinner">
      <div className="loader-holder">{children || <Loader />}</div>
    </div>
  );
};

export default FetchingSpinner;
